module.exports = __webpack_public_path__ + "images/facility-top-background.e3506bf7de0d099a47956f2d0aa9d600.png";